import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { data } from '../../data';
import examsifylineimg from '../../assest/ExamSify Lines Png.png';
import searchimg from '../../assest/search icon.png';
import './Search.css';

const boards = ['CBSE', 'Maharashtra Board', 'Karnataka Board', "M.P. Board"];
const classes = ['XII', 'XI', 'X', 'IX'];
const years = ['2025', '2024', '2023', '2022', '2021', '2020'];
const subjects = ['Mathematics', 'Physics', 'Chemistry', 'Biology', 'English', "Hindi", "Marathi", "Kannada", "Science", "Social Studies"];
const sortOptions = ['Latest Year', 'Oldest Year'];

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  const [input, setInput] = useState(query);
  const [submittedInput, setSubmittedInput] = useState(query);
  const filterRef = useRef(null);

  const [selectedBoards, setSelectedBoards] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedSort, setSelectedSort] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [suggestedItems, setSuggestedItems] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 10;

  const navigate = useNavigate();

  const handleclick = () => {
    navigate("/submit-request");
  };

  const toggleSelection = (value, listSetter, currentList) => {
    if (currentList.includes(value)) {
      listSetter(currentList.filter(item => item !== value));
    } else {
      listSetter([...currentList, value]);
    }
  };

  const sortResults = (items, sortBy) => {
    const sorted = [...items];
    if (sortBy === 'Alphabetical (A-Z)') {
      sorted.sort((a, b) => a.question.localeCompare(b.question));
    } else if (sortBy === 'Latest Year') {
      sorted.sort((a, b) => Number(b.year) - Number(a.year));
    } else if (sortBy === 'Oldest Year') {
      sorted.sort((a, b) => Number(a.year) - Number(b.year));
    }
    return sorted;
  };

  // ✅ Remove duplicates by ID
  const removeDuplicatesById = (items) => {
    const seen = new Set();
    return items.filter(item => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!submittedInput.trim()) {
      setFilteredItems([]);
      setSuggestedItems([]);
      return;
    }

    const lowerInput = submittedInput.toLowerCase();

    const exactMatches = data.filter(item => {
      if (!item.question.toLowerCase().includes(lowerInput)) return false;
      if (selectedBoards.length && !selectedBoards.includes(item.board)) return false;
      if (selectedClasses.length && !selectedClasses.includes(item.class)) return false;
      if (selectedYears.length && !selectedYears.includes(item.year)) return false;
      if (selectedSubjects.length && !selectedSubjects.includes(item.subject)) return false;
      return true;
    });

    const keywords = lowerInput.split(' ').filter(word => word.length > 2);
    const suggestions = data.filter(item =>
      keywords.some(word =>
        item.question.toLowerCase().includes(word)
      ) &&
      (selectedBoards.length ? selectedBoards.includes(item.board) : true) &&
      (selectedClasses.length ? selectedClasses.includes(item.class) : true) &&
      (selectedYears.length ? selectedYears.includes(item.year) : true) &&
      (selectedSubjects.length ? selectedSubjects.includes(item.subject) : true)
    ).filter(item => !exactMatches.includes(item));

    const sortedExact = sortResults(exactMatches, selectedSort);

    // ✅ Apply deduplication
    const uniqueSorted = removeDuplicatesById(sortedExact);

    setFilteredItems(uniqueSorted);
    setSuggestedItems(suggestions);
  }, [submittedInput, selectedBoards, selectedClasses, selectedYears, selectedSubjects, selectedSort]);

  // Reset to page 1 on filter or input change
  useEffect(() => {
    setCurrentPage(1);
  }, [submittedInput, selectedBoards, selectedClasses, selectedYears, selectedSubjects, selectedSort]);

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    setSubmittedInput(input);
  };

  const enterkey1 = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const indexOfLastResult = currentPage * resultsPerPage;
  const indexOfFirstResult = indexOfLastResult - resultsPerPage;
  const currentResults = filteredItems.slice(indexOfFirstResult, indexOfLastResult);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className='search-container1'>
        <input
          type="text"
          value={input}
          onKeyDown={enterkey1}
          onChange={(e) => setInput(e.target.value)}
          className="search-page1"
          placeholder="Search your question..."
        />
        <img src={searchimg} className='search-page-icon' alt="Search" />
        <span>
          <button className='page-btn1' onClick={handleSearch}>Find Solution</button>
        </span>
      </div>

      <div className='filter-container' ref={filterRef}>
        {[
          { key: 'board', label: 'Board', options: boards, selected: selectedBoards, setter: setSelectedBoards },
          { key: 'class', label: 'Class', options: classes, selected: selectedClasses, setter: setSelectedClasses },
          { key: 'year', label: 'Year', options: years, selected: selectedYears, setter: setSelectedYears },
          { key: 'subject', label: 'Subject', options: subjects, selected: selectedSubjects, setter: setSelectedSubjects }
        ].map(({ key, label, options, selected, setter }) => (
          <div className='filter-group' key={key}>
            <div
              className={`dropdown-header ${openDropdown === key ? 'active' : ''}`}
              onClick={() => setOpenDropdown(openDropdown === key ? null : key)}
            >
              <p>{label}</p>
            </div>
            {openDropdown === key && (
              <div className='dropdown-content'>
                {options.map(option => (
                  <label key={option} className='checkbox-option'>
                    <input
                      type="checkbox"
                      value={option}
                      checked={selected.includes(option)}
                      onChange={() => toggleSelection(option, setter, selected)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}

        <div className='filter-group'>
          <div
            className={`dropdown-header ${openDropdown === 'sort' ? 'active' : ''}`}
            onClick={() => setOpenDropdown(openDropdown === 'sort' ? null : 'sort')}
          >
            <p>Sort By</p>
          </div>
          {openDropdown === 'sort' && (
            <div className='dropdown-content'>
              {sortOptions.map(option => (
                <label key={option} className='checkbox-option'>
                  <input
                    type="radio"
                    name="sort"
                    value={option}
                    checked={selectedSort === option}
                    onChange={() => setSelectedSort(option)}
                  />
                  {option}
                </label>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className='page-container'>
        <img src={examsifylineimg} alt="Design Line" />
        <div className='page-wrapper'>
          {filteredItems.length > 0 ? (
            <>
              <ul className="result-list">
                {currentResults.map(item => (
                  <li key={item.id} className="result-item">
                    <h4>{item.question}</h4>
                    <p className="truncated-text">{item.answer}</p>
                    <span>
                      <Link to={`/answer/${item.id}`} className="view-more-link">View Solution</Link>
                      <span className='class-year'>({item.class}, {item.year})</span>
                    </span>
                  </li>
                ))}
              </ul>

              <div className="pagination">
                {Array.from({ length: Math.ceil(filteredItems.length / resultsPerPage) }, (_, i) => (
                  <button
                    key={i + 1}
                    className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </>
          ) : (
            <div className="no-result">
              <p>Apologies, we do not have this answer. Kindly submit a request.</p>
              <button className='no-result-button' onClick={handleclick}>Submit Request</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchPage;
